import { render, staticRenderFns } from "./SchoolView.vue?vue&type=template&id=f438ccf8&"
import script from "./SchoolView.vue?vue&type=script&lang=js&"
export * from "./SchoolView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports